module.exports = __webpack_public_path__ + "static/media/colchaguaLogo.228dcfb0.png";